import { useContext, useRef, useMemo } from 'react';
import AnalyticsContext$1 from '../AnalyticsContext/AnalyticsContext.js';
import '../AnalyticsContext/index.js';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../_virtual/_rollupPluginBabelHelpers.js';

var useAnalytics = function useAnalytics(_ref, defaultProps) {
  var analytics = _ref.analytics,
      restProps = _objectWithoutPropertiesLoose(_ref, ["analytics"]);

  var _useContext = useContext(AnalyticsContext$1),
      track = _useContext.track;

  var eventHandlers = useRef({});
  eventHandlers.current = useMemo(function () {
    if (analytics) {
      var actions = analytics.actions;

      if (analytics.value && !analytics.actions) {
        actions = defaultProps.analytics.actions;
      }

      var handleTrack = function handleTrack(eventProp, event, opts) {
        restProps[eventProp] && restProps[eventProp](event, opts);
        var action = actions[eventProp];

        if (action) {
          var payload = action.payload;

          if (payload && typeof payload === 'object' && typeof payload.data === 'function') {
            payload.data = payload.data(event, opts);
          }
        }

        track && track(analytics.value, action, event);
      };

      return Object.keys(actions).reduce(function (handlers, prop) {
        handlers[prop] = function (event, opts) {
          return handleTrack(prop, event, opts);
        };

        return handlers;
      }, {});
    }

    return {};
  }, [analytics, restProps, defaultProps, track]);
  return [track, eventHandlers.current];
};

export default useAnalytics;
